import { css, cx } from "@emotion/css";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AccordionDetails } from "src/components/Default/LekUI/Accordion";
import RelationView from "src/components/NewComponents/Relations/RelationView";
import { isRelation } from "src/components/Relations/plugins";
import { isTouchable } from "src/helpers/isMobile";
import { getAppConfig } from "src/hooks/useAppConfig";
import { useNoCopy } from "src/hooks/useNoCopy";

import { htmlFormatter } from "../../../../formatters/htmlFormatter";
import isMobile from "../../../../helpers/isMobile";
import isPes from "../../../../helpers/isPes";
import { useFontSize } from "../../../../hooks/useFontSize";
import { useResizeObserver } from "../../../../hooks/useResizeObserver";
import Gallery from "../../Images/Gallery";
import ContentActions from "./ContentActions";

function Content({ section, deprecatedArticleId, isOpen }) {
	const appConfig = getAppConfig();
	const { onCopy, noCopyClassName } = useNoCopy({
		config: appConfig.copyContentSettings.articles,
	});
	const { fontSizeClass, fontSizeDeepClass, getFontSizeClass } = useFontSize();
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);
	const [boxWidth, setBoxWidth] = useState(null);
	const ref = useRef();
	useResizeObserver(ref, (entry) => {
		setBoxWidth(entry.contentRect.width);
	});

	const showRelation = (e) => {
		clearTimeout(ref.timeout);
		ref.timeout = setTimeout(() => {
			if (isRelation(e)) {
				e.stopPropagation();
				e.preventDefault();
				setAnchorEl(anchorEl ? null : e.target);
			}
		}, 200);
	};

	const renderRelation = () => {
		if (isPes()) {
			return null;
		}

		return (
			anchorEl && <RelationView anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
		);
	};

	const renderImages = (imgs) => {
		if (!imgs.length) {
			return null;
		}

		const images = imgs.map((img) => ({
			image: img.src,
			title: img.title,
		}));

		return (
			<>
				<Divider />
				<Box sx={{ marginTop: "4px" }}>
					<span className={getFontSizeClass(-2)}>{t("articles.images")}</span>
					<Gallery images={images} maxImages={isMobile() ? 3 : 7} />
				</Box>
			</>
		);
	};

	const getSectionAction = () => {
		return {
			[isTouchable() ? "onClick" : "onMouseOver"]: (e) => showRelation(e),
		};
	};

	return (
		<AccordionDetails>
			<Box ref={ref}>
				{renderRelation()}
				{boxWidth && (
					<section
						onCopy={onCopy}
						tabIndex={-1}
						className={cx(
							"fr-view",
							noCopyClassName,
							fontSizeClass,
							fontSizeDeepClass,
							css`
                .table-main-wrapper {
                  max-width: ${boxWidth}px;
                }

                .table-wrapper {
                  max-width: min(calc(100vw - 70px), ${boxWidth}px);

                  table {
                    ${isOpen ? "white-space: nowrap;" : ""}
                  }
                }
              `,
						)}
						{...getSectionAction()}
					>
						{htmlFormatter(section.content)}
					</section>
				)}
			</Box>
			{renderImages(section.images)}
			<ContentActions
				section={section}
				deprecatedArticleId={deprecatedArticleId}
			/>
		</AccordionDetails>
	);
}

export default Content;
